export default "__VITE_ASSET__2a69774e__"